module.exports = __webpack_public_path__ + "img/pc-kcidea.86ad6575.svg";